/* App shell (sidebar, top bar, account menu), login page, dashboard and the
 * first-login onboarding walkthrough. */
const shell = {
  // --- Sidebar navigation -------------------------------------------------
  'Dashboard': 'Dasbor',
  'Sourcing': 'Pengadaan Sumber',
  'Catalog': 'Katalog',
  'Menu Engineering': 'Rekayasa Menu',
  'Purchasing': 'Pembelian',
  'Requisitions': 'Permintaan Barang',
  'Market List': 'Daftar Belanja Pasar',
  'Purchase Orders': 'Pesanan Pembelian',
  'Receiving': 'Penerimaan',
  'Returns': 'Retur',
  'Inventory': 'Inventaris',
  'Stock on Hand': 'Stok Tersedia',
  'Stock Counts': 'Penghitungan Stok',
  'Transfers': 'Transfer',
  'Usage & Variance': 'Pemakaian & Selisih',
  'Finance': 'Keuangan',
  'Budgets': 'Anggaran',
  'Invoices': 'Faktur',
  'Reports': 'Laporan',
  'Administration': 'Administrasi',
  'Users & roles': 'Pengguna & peran',
  'Settings': 'Pengaturan',

  // --- Top bar / property switcher / account menu -------------------------
  'All properties': 'Semua properti',
  'Active property': 'Properti aktif',
  'No properties yet': 'Belum ada properti',
  'My account': 'Akun saya',
  'Getting started': 'Panduan awal',
  'Sign out': 'Keluar',

  // --- Login page ----------------------------------------------------------
  'Advanced stock & procurement, built into your stack.': 'Manajemen stok & pengadaan canggih, terintegrasi dengan sistem Anda.',
  'Source, purchase, receive and track inventory across all your properties — fully interconnected with Prostay and TableView.': 'Cari, beli, terima, dan lacak inventaris di semua properti Anda — terhubung penuh dengan Prostay dan TableView.',
  'Procure-to-pay, purchase orders & approvals': 'Procure-to-pay, pesanan pembelian & persetujuan',
  'Real-time inventory across every location': 'Inventaris real-time di setiap lokasi',
  'Native to the Prostay & TableView ecosystem': 'Bagian asli ekosistem Prostay & TableView',
  'Welcome back': 'Selamat datang kembali',
  'Sign in to your procurement workspace.': 'Masuk ke ruang kerja pengadaan Anda.',
  'Password': 'Kata sandi',
  'Sign in': 'Masuk',
  'Sign in failed.': 'Gagal masuk.',
  'Invalid email or password.': 'Email atau kata sandi salah.',
  'Please enter your email and password.': 'Silakan masukkan email dan kata sandi Anda.',
  'Prostay Procurement & Inventory · Secure access': 'Prostay Pengadaan & Inventaris · Akses aman',
  'or': 'atau',
  'Sign in with passkey': 'Masuk dengan passkey',
  'Passkey sign-in failed.': 'Gagal masuk dengan passkey.',

  // --- Forgot / reset password ----------------------------------------------
  'Forgot password?': 'Lupa kata sandi?',
  'Forgot your password?': 'Lupa kata sandi Anda?',
  "It happens. We'll email you a link to choose a new one.":
    'Tidak masalah. Kami akan mengirimkan tautan lewat email untuk memilih kata sandi baru.',
  'Reset your password': 'Atur ulang kata sandi Anda',
  "Enter the email you sign in with and we'll send you a reset link.":
    'Masukkan email yang Anda gunakan untuk masuk dan kami akan mengirimkan tautan pengaturan ulang.',
  'Email me a reset link': 'Kirimkan tautan pengaturan ulang',
  'Check your email': 'Periksa email Anda',
  'If an account exists for {email}, a reset link is on its way. The link expires in 60 minutes.':
    'Jika ada akun untuk {email}, tautan pengaturan ulang sedang dikirim. Tautan kedaluwarsa dalam 60 menit.',
  'Send again': 'Kirim ulang',
  'Back to sign in': 'Kembali ke halaman masuk',
  'Something went wrong. Please try again.': 'Terjadi kesalahan. Silakan coba lagi.',
  'Choose a new password': 'Pilih kata sandi baru',
  "You'll be signed out everywhere else, then you can sign back in with the new password.":
    'Anda akan dikeluarkan dari perangkat lain, lalu dapat masuk kembali dengan kata sandi baru.',
  'Almost there — pick something strong and memorable.':
    'Hampir selesai — pilih kata sandi yang kuat dan mudah diingat.',
  'Set new password': 'Simpan kata sandi baru',
  'Password updated': 'Kata sandi diperbarui',
  'You can sign in with your new password now. Redirecting…':
    'Anda dapat masuk dengan kata sandi baru sekarang. Mengalihkan…',
  'Reset link invalid': 'Tautan pengaturan ulang tidak valid',
  'This reset link is invalid or incomplete. Request a new one.':
    'Tautan pengaturan ulang ini tidak valid atau tidak lengkap. Minta yang baru.',
  'Request a new link': 'Minta tautan baru',
  'Link expired? Request a new one': 'Tautan kedaluwarsa? Minta yang baru',
  'Could not reset the password.': 'Tidak dapat mengatur ulang kata sandi.',

  // --- Dashboard -----------------------------------------------------------
  'Welcome, {name}': 'Selamat datang, {name}',
  'there': 'Anda',
  'Your procurement and inventory at a glance.': 'Pengadaan dan inventaris Anda dalam sekilas.',
  'Failed to load the dashboard.': 'Gagal memuat dasbor.',
  'My approvals': 'Persetujuan saya',
  'Waiting on you': 'Menunggu Anda',
  'Nothing pending': 'Tidak ada yang menunggu',
  'Open purchase orders': 'Pesanan pembelian terbuka',
  'Awaiting receipt': 'Menunggu penerimaan',
  'POs not fully received': 'PO belum diterima sepenuhnya',
  'Invoices to review': 'Faktur untuk ditinjau',
  'Draft + in approval': 'Draf + dalam persetujuan',
  'AP outstanding': 'Utang usaha berjalan',
  '{amount} overdue ({count})': '{amount} jatuh tempo ({count})',
  'Nothing overdue': 'Tidak ada yang jatuh tempo',
  'Inventory value': 'Nilai inventaris',
  'On-hand at average cost': 'Stok tersedia pada biaya rata-rata',
  'Documents waiting on your decision': 'Dokumen menunggu keputusan Anda',
  'No approvals waiting': 'Tidak ada persetujuan menunggu',
  'When a requisition, purchase order or invoice needs your sign-off, it shows up here.': 'Saat permintaan barang, pesanan pembelian, atau faktur membutuhkan persetujuan Anda, dokumen itu muncul di sini.',
  'On behalf': 'Atas nama',
  'Requisition': 'Permintaan Barang',
  'PO': 'PO',
  'Invoice': 'Faktur',
  'Overdue deliveries': 'Pengiriman terlambat',
  'Past their expected date': 'Melewati tanggal perkiraan',
  'Purchase orders past their expected date without delivery': 'Pesanan pembelian yang melewati tanggal perkiraan tanpa pengiriman',
  '{n} day(s) late': 'terlambat {n} hari',
  'expected {date}': 'perkiraan {date}',
  'Low-stock alerts': 'Peringatan stok menipis',
  'Items at or below their reorder point': 'Barang pada atau di bawah titik pemesanan ulang',
  'Nothing to reorder': 'Tidak ada yang perlu dipesan ulang',
  'Set par levels on your catalog items to get reorder alerts here.': 'Atur level par pada barang katalog Anda untuk mendapat peringatan pemesanan ulang di sini.',
  'on hand / par': 'tersedia / par',

  // --- New-version popup -----------------------------------------------------
  'A new version is available': 'Versi baru tersedia',
  'We just shipped an update. Refresh to make sure everything works as intended.':
    'Kami baru saja merilis pembaruan. Muat ulang agar semuanya berfungsi sebagaimana mestinya.',
  "What's new": 'Apa yang baru',
  'If you are in the middle of something, save your work first — refreshing discards unsaved changes.':
    'Jika Anda sedang mengerjakan sesuatu, simpan dulu pekerjaan Anda — memuat ulang akan menghapus perubahan yang belum disimpan.',
  'Refresh now': 'Muat ulang sekarang',
  'Later': 'Nanti',
  "You're on the latest version — here's what changed in the most recent update.":
    'Anda menggunakan versi terbaru — inilah yang berubah pada pembaruan terakhir.',
  'Got it': 'Mengerti',

  // --- Onboarding walkthrough ----------------------------------------------
  'Welcome': 'Selamat datang',
  'This system does one simple thing: it helps your property': 'Sistem ini melakukan satu hal sederhana: membantu properti Anda',
  'ask for things, buy them, receive them, and pay for them': 'meminta barang, membelinya, menerimanya, dan membayarnya',
  '— without paperwork getting lost.': '— tanpa ada dokumen yang hilang.',
  'Setup takes about two minutes: pick your language, add your signature, then a quick tour of how buying works here. No purchasing experience needed.': 'Penyiapan hanya sekitar dua menit: pilih bahasa Anda, tambahkan tanda tangan, lalu tur singkat tentang cara kerja pembelian di sini. Tidak perlu pengalaman purchasing.',
  'Your language': 'Bahasa Anda',
  'Pick the language you’d like to use. You can change this any time in My account.': 'Pilih bahasa yang ingin Anda gunakan. Anda dapat mengubahnya kapan saja di Akun saya.',
  'Language': 'Bahasa',
  'Add your signature': 'Tambahkan tanda tangan Anda',
  'Your signature is stamped automatically when you submit or approve documents, so you never have to sign by hand. This step is required to continue.': 'Tanda tangan Anda dibubuhkan otomatis saat Anda mengajukan atau menyetujui dokumen, jadi Anda tidak perlu menandatangani secara manual. Langkah ini wajib untuk melanjutkan.',
  'Signature saved': 'Tanda tangan tersimpan',
  'Could not save signature': 'Tidak dapat menyimpan tanda tangan',
  'Could not remove signature': 'Tidak dapat menghapus tanda tangan',
  'Your signature': 'Tanda tangan Anda',
  'No signature yet': 'Belum ada tanda tangan',
  'Draw it, type it, or upload an image below — then save.': 'Gambar, ketik, atau unggah gambar di bawah — lalu simpan.',
  'Save a signature to continue': 'Simpan tanda tangan untuk melanjutkan',
  'How buying works — one story, five steps': 'Cara kerja pembelian — satu alur, lima langkah',
  'Everything your property buys follows the same journey. Learn this once and the whole system makes sense.': 'Semua yang dibeli properti Anda mengikuti alur yang sama. Pahami sekali, dan seluruh sistem jadi masuk akal.',
  'Ask': 'Minta',
  'Write down what you need': 'Tulis apa yang Anda butuhkan',
  'Running low on rice, towels, printer paper? Create a requisition — a simple list of what you need and how much.': 'Beras, handuk, atau kertas printer menipis? Buat permintaan barang — daftar sederhana tentang apa yang Anda butuhkan dan berapa banyak.',
  'Like a shopping list you hand to your manager.': 'Seperti daftar belanja yang Anda serahkan ke manajer.',
  'A manager says yes': 'Manajer menyetujui',
  'Your list goes to the right person automatically. They review it and approve — your saved signature is stamped for you.': 'Daftar Anda otomatis sampai ke orang yang tepat. Mereka meninjau dan menyetujui — tanda tangan tersimpan Anda dibubuhkan secara otomatis.',
  'Like getting a thumbs-up before spending the money.': 'Seperti mendapat lampu hijau sebelum mengeluarkan uang.',
  'Order': 'Pesan',
  'It becomes an official order': 'Menjadi pesanan resmi',
  'The approved list turns into a purchase order (PO) that is sent to the supplier. No retyping — it happens on its own.': 'Daftar yang disetujui berubah menjadi pesanan pembelian (PO) yang dikirim ke pemasok. Tanpa mengetik ulang — semuanya otomatis.',
  'Like a formal “please deliver this” letter to the shop.': 'Seperti surat resmi “tolong kirim barang ini” kepada toko.',
  'Receive': 'Terima',
  'Tick off what arrives': 'Centang apa yang datang',
  'When the delivery shows up, open the order and confirm what actually came. Stock on hand updates by itself.': 'Saat kiriman tiba, buka pesanan dan konfirmasi apa yang benar-benar datang. Stok tersedia diperbarui dengan sendirinya.',
  'Like checking the bags against the receipt before the driver leaves.': 'Seperti memeriksa belanjaan dengan struk sebelum kurir pergi.',
  'Pay': 'Bayar',
  'Check the bill, then pay': 'Periksa tagihan, lalu bayar',
  'The supplier’s invoice is matched against what you ordered and what arrived. If the numbers agree, it’s approved for payment.': 'Faktur pemasok dicocokkan dengan apa yang Anda pesan dan yang tiba. Jika angkanya cocok, faktur disetujui untuk dibayar.',
  'Like comparing the bill with your receipt so you never overpay.': 'Seperti membandingkan tagihan dengan struk agar Anda tidak pernah membayar lebih.',
  'Approvals': 'Persetujuan',
  'Your everyday tools': 'Alat sehari-hari Anda',
  'Not everything is a big order. These handle the day-to-day — all in the sidebar.': 'Tidak semua hal berupa pesanan besar. Ini menangani kebutuhan sehari-hari — semuanya ada di bilah samping.',
  'Market lists': 'Daftar belanja pasar',
  'For quick daily buys — the wet market, fresh produce, cash purchases. Faster than a requisition, always in your property’s local currency.': 'Untuk belanja harian cepat — pasar basah, bahan segar, pembelian tunai. Lebih cepat dari permintaan barang, selalu dalam mata uang lokal properti Anda.',
  'Stock on hand & counts': 'Stok tersedia & penghitungan',
  'See what you have right now, and do regular counts to make sure the system matches the shelf.': 'Lihat apa yang Anda miliki saat ini, dan lakukan penghitungan rutin agar sistem sesuai dengan rak.',
  'Move stock between locations — say, from the main store to the kitchen — so usage is tracked to the right place.': 'Pindahkan stok antar lokasi — misalnya dari gudang utama ke dapur — agar pemakaian tercatat di tempat yang benar.',
  'Catalog & suppliers': 'Katalog & pemasok',
  'The item catalog is your dictionary of everything you buy; suppliers hold contacts, prices and bank details.': 'Katalog barang adalah kamus semua yang Anda beli; pemasok menyimpan kontak, harga, dan detail bank.',
  'If this happens… do that': 'Jika ini terjadi… lakukan itu',
  'Your pocket guide. You can reopen this tour any time from your avatar menu →': 'Panduan saku Anda. Anda dapat membuka kembali tur ini kapan saja dari menu avatar →',
  'We’re running low on something': 'Persediaan kami mulai menipis',
  'Create a requisition': 'Buat permintaan barang',
  'I’m buying fresh goods at the market today': 'Saya belanja bahan segar di pasar hari ini',
  'Use a market list': 'Gunakan daftar belanja pasar',
  'Market Lists': 'Daftar Belanja Pasar',
  'A delivery just arrived at the door': 'Kiriman baru saja tiba',
  'Record what came in': 'Catat apa yang masuk',
  'A supplier sent us a bill': 'Pemasok mengirimkan tagihan',
  'Enter it and match it to the order': 'Masukkan dan cocokkan dengan pesanan',
  'The kitchen needs stock from the store': 'Dapur butuh stok dari gudang',
  'Make a transfer': 'Buat transfer',
  'The shelf doesn’t match the system': 'Isi rak tidak cocok dengan sistem',
  'Do a stock count': 'Lakukan penghitungan stok',
  'Counts': 'Penghitungan',
  'Golden rule:': 'Aturan emas:',
  'if it costs money, it starts with a requisition. When in doubt, raise one — the system routes it to the right person.': 'jika mengeluarkan uang, mulailah dengan permintaan barang. Jika ragu, buat saja — sistem akan meneruskannya ke orang yang tepat.',
  'You’re all set — welcome aboard!': 'Semua siap — selamat bergabung!',
  'Could not finish setup': 'Tidak dapat menyelesaikan penyiapan',
  'Finish setup': 'Selesaikan penyiapan',
};

export default shell;
